import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";

// Below-the-fold + heavy components are code-split so they don't block
// the critical hero render. Footer + WhatsApp float load after main paint.
const Footer = React.lazy(() => import("@/components/Footer"));
const WhatsAppFloat = React.lazy(() => import("@/components/WhatsAppFloat"));

import Home from "@/pages/Home";
const Properties = React.lazy(() => import("@/pages/Properties"));
const PropertyDetail = React.lazy(() => import("@/pages/PropertyDetail"));
const About = React.lazy(() => import("@/pages/About"));
const Contact = React.lazy(() => import("@/pages/Contact"));
const Terms = React.lazy(() => import("@/pages/Terms"));
const AdminLogin = React.lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = React.lazy(() => import("@/pages/AdminDashboard"));

function RouteLoader() {
  return <div className="max-w-7xl mx-auto px-4 py-16 text-[#4A4A5A]" data-testid="route-loader">Loading…</div>;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar/>}
      <main>{children}</main>
      <React.Suspense fallback={null}>
        {!isAdmin && <Footer/>}
        {!isAdmin && <WhatsAppFloat/>}
      </React.Suspense>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell>
            <React.Suspense fallback={<RouteLoader/>}>
              <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/properties" element={<Properties/>}/>
                <Route path="/properties/:slug" element={<PropertyDetail/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/terms" element={<Terms/>}/>
                <Route path="/admin/login" element={<AdminLogin/>}/>
                <Route path="/admin" element={<AdminDashboard/>}/>
                <Route path="*" element={<Home/>}/>
              </Routes>
            </React.Suspense>
          </Shell>
          <Toaster position="top-right" richColors closeButton/>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
